import { render, staticRenderFns } from "./OptoutMessagesVariations.vue?vue&type=template&id=2cb16f72"
import script from "./OptoutMessagesVariations.vue?vue&type=script&lang=js"
export * from "./OptoutMessagesVariations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports